import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { BaseStore } from "@client/lib/base-store";
import { Observable } from "rxjs";
import { State } from "@client/reducers/profile-details-reducer";
import { getProfileDetailsIsActive } from "@client/selectors";
/*test*/ 
@Injectable()
export class ProfileDetailsStore extends BaseStore {
    get isActive(): Observable<boolean> {
        return this.store.pipe(select(getProfileDetailsIsActive));
    }
}
